import { createContext } from 'react';
import { createMachine, assign } from "xstate";

export const errorMachine = createMachine({
    id: "errorDataFetch",
    initial: "wating",
    context: { message: null, type:"error"} as {message: string | null, type:'info' | 'success' | 'error' | 'warning' | 'loading'},
    states: {
      wating: {
        on: {
            ERROR: { target: "error"  },
        },
        entry: assign({
        message: () => null,
        type: () => "error"
      }),

      },
      error: {
        after: { 100: "wating" },
        entry: assign({
        message: ({ event }) => event.data?.message || "Ocurrió un error",
        type: ({ event }) => event.data?.type || "error"
      }),
      },

    },
  }, 
);

export const PromiseSesionContext = createContext<any>({});
